<template>
    <div class="d-card">
        <header
            v-if="title || titleRight || titleMiddle || subtitle"
            class="flex flex-column"
        >
            <div>
                <span
                    v-if="mainTitleHasSlot === false"
                    :class="titleMiddle !== '' ? 'width-51' : ''"
                >{{ title }}</span>
                <span
                    v-if="mainTitleHasSlot === true"
                    :class="[titleMiddle !== '' ? 'width-51' : '', 'title-has-slot']"
                >
                    <span>{{ title }}</span>
                    <slot name="titleHasSlot" />
                </span>
                <span v-if="titleRight">{{ titleRight }}</span>
                <span
                    v-if="titleMiddle"
                    :class="['title-middle', mainTitleHasSlot === true ? 'mt-2' : '']"
                >{{ titleMiddle }}</span>
                <span v-if="hintRight"><small class="text-muted">{{ hintRight }}</small></span>
            </div>
            <div v-if="subtitle">
                <span><small class="text-muted">{{ subtitle }}</small></span>
            </div>
        </header>
        <main :class="padding ? `padding ${mainClass}` : mainClass">
            <slot />
        </main>
        <footer
            v-if="hasFooterSlot"
            :class="footerPadding ? 'padding' : ''"
        >
            <slot name="footer" />
        </footer>
    </div>
</template>

<script>

export default {
    name: 'DCard',
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        titleRight: {
            type: String,
            required: false,
            default: ''
        },
        hintRight: {
            type: String,
            required: false,
            default: ''
        },
        subtitle: {
            type: String,
            required: false,
            default: ''
        },
        padding: {
            type: Boolean,
            required: false,
            default: false
        },
        footerPadding: {
            type: Boolean,
            required: false,
            default: false
        },
        titleMiddle: {
            type: String,
            required: false,
            default: ''
        },
        mainTitleHasSlot: {
            type: Boolean,
            required: false,
            default: false
        },
        mainClass: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        hasFooterSlot () {
            return !!this.$slots.footer
        }
    }
}
</script>

<style lang="scss" scoped>
.d-card {
    background: var(--colorAppSurface);
    border-radius: 5px;
    border: 1px solid var(--colorAppBorder);

    & header {
        padding: 10px 15px;
        border-bottom: 1px solid var(--colorAppBorder);
        display: flex;
        justify-content: space-between;

        .width-51 {
            width: 51%;
        }

        .title-middle {
            flex: auto;
        }
    }

    & main {
        &.padding {
            padding: 15px;
        }
    }
    & footer {
        border-top: 1px solid var(--colorAppBorder);

        &.padding {
            padding: 15px;
        }
    }
}
.title-has-slot{
    display: flex;
    align-items: center;
    grid-gap: 5px;
}
</style>
